<mib-modal size="md" [showCloseButton]="false">
  <svg mib-modal-header mib-logo-medinbox class="h-6 text-mib-branding-900"></svg>

  <div mib-modal-content>
    <div class="text-gray-900 flex flex-col gap-4">
      @if (showGuestForm()) {
        <div>
          <h2
            class="text-2xl not-height-medium:mt-4 not-height-medium:text-xl text-mib-branding-900">
            Guest Access - Terms and Information
          </h2>
          <!-- When needed, Guest form comes first -->
          <div class="pb-8 border-b border-mib-hairline">
            <p class="mb-4 text-base text-gray-900">Please provide your information to continue:</p>
            <mai-guest-disclaimer-form
              [formData]="$safeNavigationMigration(data?.formData)"
              (formSubmitted)="onGuestFormSubmitted($event)"></mai-guest-disclaimer-form>
          </div>
        </div>
      }
      <!-- Terms and conditions (scrollable) -->
      <h3 class="mb-2 text-2xl text-mib-branding-900">
        Welcome to the Medinbox Intelligence demo environment.
      </h3>
      <p>
        You are about to access medical video content made available for educational and evaluation
        purposes only.
      </p>
      <p>
        Please confirm that you are authorized to view and use this content solely for legitimate
        professional or educational evaluation. This system provides access to recorded medical
        procedures and related materials intended exclusively for training, education, and
        information sharing among healthcare professionals.
      </p>

      <p>
        Medinbox Intelligence Assistant (MIA) helps users explore and understand the video content
        more efficiently. Its responses are for informational purposes only and must not be
        interpreted as medical advice, diagnosis, or treatment recommendations. Users remain fully
        responsible for their own professional judgment and must follow applicable clinical
        protocols and institutional guidelines.
      </p>
      <p>
        This content is not intended for diagnostic, therapeutic, or real-time clinical use, and
        should never replace consultation with a qualified physician.
      </p>
      <p>
        All videos and associated materials remain the exclusive property of their respective
        authors and institutions. They are protected by intellectual property laws and must not be
        copied, recorded, distributed, or shared in any form without prior written authorization
        from Medinbox or the rightful content owners.
      </p>
      <p>
        By clicking "I accept", you confirm that you understand and agree to these terms, that your
        access may be logged for compliance purposes, and that you will use this system solely for
        legitimate educational and evaluation purposes.
      </p>
    </div>
  </div>

  <div mib-modal-footer class="flex w-full justify-center gap-4">
    <button mibButton type="button" class="w-full" theme="secondary" (click)="onRefuse()">
      I refuse
    </button>
    <button
      mibButton
      type="button"
      class="w-full"
      [disabled]="showGuestForm() && !isFormValid()"
      (click)="onAccept()">
      I accept
    </button>
  </div>
</mib-modal>
